/**
 * Welcome Screen Component
 * 
 * Displays the initial welcome screen with examples when chat is empty.
 */

import React from "react";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import { welcomeExamples } from "../mocks/venchy.mock";
import styles from "../venchy.module.css";

interface IWelcomeScreenProps {
  userName: string;
  onExampleClick: (prompt: string) => void;
}

const WelcomeScreen: React.FC<IWelcomeScreenProps> = ({
  userName,
  onExampleClick
}) => {
  return (
    <div className={styles.venchyWelcomeScreen}>
      <div className={styles.venchyWelcomeIcon}>👋</div>
      <div className={styles.venchyWelcomeTitle}>
        {t("VENCHY_WELCOME_TITLE")}
      </div>
      <div className={styles.venchyWelcomeSubtitle}>
        {t("VENCHY_WELCOME_SUBTITLE")}
      </div>
      <div className={styles.venchyWelcomeExamples}>
        {welcomeExamples.map(example => (
          <div 
            key={example.id}
            className={styles.venchyExampleItem}
            onClick={() => onExampleClick(t(example.prompt))}
          >
            {t(example.textKey)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WelcomeScreen;
